import { WatercraftTypeState } from "./types";

export const defaultState = (): WatercraftTypeState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    watercraftTypes: [],
    links: {}
  };
};

export const state = defaultState();
